import { ReactNode } from 'react'
import styles from './HeaderContainerBorderless.module.scss'

export type HeaderContainerBorderlessProps = {
  children: ReactNode
}
export default function HeaderContainerBorderless(
  props: HeaderContainerBorderlessProps
): JSX.Element {
  const { children } = props
  return <div className={styles.container}>{children}</div>
}
